import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { value: "" }
const _hoisted_2 = ["value"]

import { ref, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import ValidatableField from '@/components/ValidatableField.vue';
import { RuleExpression } from 'vee-validate';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';

type SelectOption = {
  id: string | number;
  text: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendSelect',
  props: {
    name: null,
    modelValue: { default: '' },
    id: null,
    label: null,
    rules: null,
    className: null,
    emptyText: { default: '選択してください' }
  },
  setup(__props: any) {

const props = __props as { name: string, modelValue: string | number | null, id?: string, label?: string, rules?: RuleExpression<unknown>, className: string, emptyText: string }



const selected = ref(Number(props.modelValue) ? props.modelValue : '');

watch(() => props.modelValue, (newVal) => {
  selected.value = Number(newVal) ? newVal : '';
});

const store = useStore();

const options = ref<Array<SelectOption>>([]);

async function loadSelectData() {
  const storeBase = MYPAGE_CONSTANTS.STORE_MST;
  try {
    switch (props.id) {
      case 'form-area': {
        const data = await store.dispatch(storeBase.MST_PREF);
        options.value = data as SelectOption[];
        break;
      }
      case 'form-move': {
        const data = await store.dispatch(storeBase.MST_CHANGE_ADDR);
        options.value = data as SelectOption[];
        break;
      }
      case 'form-employees': {
        const data = await store.dispatch(storeBase.MST_EMPLOYEE);
        options.value = data as SelectOption[];
        break;
      }
      case 'form-relocate': {        
        const data = await store.dispatch(storeBase.MST_JOB_CHANGE_TIME);
        options.value = data as SelectOption[];
        break;
      }
      case 'form-industry-fase': {        
        const data = await store.dispatch(storeBase.MST_SELECTION_PHASE);
        options.value = data as SelectOption[];
        break;
      }
      case 'form-industry-interest': {        
        const data = await store.dispatch(storeBase.MST_ASPIRATION);
        options.value = data as SelectOption[];
        break;
      }
      case 'form-industry-route': {        
        const data = await store.dispatch(storeBase.MST_COURSE);
        options.value = data as SelectOption[];
        break;
      }
    }
  } catch (error) {
    console.error(`Error loading select data for ${props.name}:`, error);
  }
}

onMounted(async () => {
  await loadSelectData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ValidatableField, {
    as: "select",
    class: _normalizeClass([__props.className, {'--has-value': !!selected.value}]),
    id: __props.id || __props.name,
    name: __props.name,
    rules: __props.rules,
    label: __props.label,
    "model-value": selected.value,
    "onUpdate:model-value": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
    value: selected.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("option", _hoisted_1, _toDisplayString(__props.emptyText), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: option.id,
          value: option.id
        }, _toDisplayString(option.text), 9, _hoisted_2))
      }), 128))
    ]),
    _: 1
  }, 8, ["class", "id", "name", "rules", "label", "model-value", "value"]))
}
}

})